/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoComboBox implements angular.IDirective {
        private filter: angular.IFilterService;
        restrict = "E";
        scope = {
            name: "@",
            id: "@",
            array: "=",
            currentValue: '=ngModel',
            contentKey: "@"
        };

        template = "<label translate=\"{{::contentKey}}\"></label><select ng-model=\"currentValue\" ng-options=\"a[optionValue] as a[optionDescription] for a in array\">" +
                        "<option style=\"dislay: none\" value=\"\"></option>" +
                    "</select>";

        constructor($filter: angular.IFilterService) {
            this.filter = $filter;
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var filter = this.filter;

            scope.optionValue = attrs['optionValue'];
            scope.optionDescription = attrs['optionDescription'];

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter) => {
                return new MeevoComboBox($filter);
            };

            directive.$inject = ["$filter"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoComboBox", MeevoComboBox.factory());
}